import React, { useRef } from 'react';
import { Input } from '@ais-ui/ui-core';
import { PiMagnifyingGlass, PiX } from 'react-icons/pi';
import { useLocalization } from '@ais-ui/locale-management';

interface HelpHeaderProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  showCloseButton?: boolean;
  onClose?: () => void;
}

export const HelpHeader: React.FC<HelpHeaderProps> = ({
  searchQuery,
  onSearchChange,
  showCloseButton = false,
  onClose,
}) => {
  const { messages } = useLocalization();
  const searchInputRef = useRef<HTMLInputElement>(null);

  // Auto-focus search input on mount
  React.useEffect(() => {
    searchInputRef.current?.focus();
  }, []);

  return (
    <div className="flex items-center w-full">
      {/* Title section - matches sidebar width minus header px-4 padding (256px - 16px = 240px = w-60) */}
      <div className="w-60 flex-shrink-0">
        <h1 className="text-xl font-bold text-foreground">
          {messages.helpTitle || 'Help articles'}
        </h1>
      </div>

      {/* Search section - aligned with main content */}
      <div className="flex-1 flex items-center justify-between">
        <div className="relative w-80">
          <PiMagnifyingGlass className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            ref={searchInputRef}
            placeholder={
              messages.helpSearchPlaceholder || 'Search articles...'
            }
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full pl-10 h-10 text-sm border-input bg-background"
          />
        </div>

        {/* Close button for popup mode */}
        {showCloseButton && onClose && (
          <button
            className="rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
            onClick={onClose}
          >
            <PiX className="h-5 w-5" />
          </button>
        )}
      </div>
    </div>
  );
};
